export default "__VITE_ASSET__08f0ac00__"